import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { AuthenticationService, HeaderService } from '../../_services';
import { User } from '../../_models'
import { ToastrService } from 'ngx-toastr';
import { TranslateService } from '@ngx-translate/core';
import { Router } from '@angular/router';
declare const $: any;

@Component({ 
  selector: 'app-login',
  templateUrl: 'login.component.html' 
})
export class LoginComponent implements OnInit {

  loginForm: FormGroup;
  //20250602 axa inici
  //loading = false;
  loadingSTD = false;
  loadingAxA = false;
  //20250602 axa final
  submitted = false;
  currentUser: User;

  public showLogin : boolean;

  constructor(
    private formBuilder: FormBuilder,
    private auth: AuthenticationService,
    private toastr : ToastrService,
    private translate : TranslateService,
    private header: HeaderService,
    private router : Router
  ) {
    
    this.header.showLogin.subscribe( s => {
      this.showLogin = s;
    });

    this.auth.currentUser.subscribe( user => {
      this.currentUser = user;
    });    

   }

  ngOnInit() {
    
    this.loginForm = this.formBuilder.group({
      username: ['', Validators.required],
      password: ['', [Validators.required, Validators.maxLength(10), Validators.minLength(1)]]
    });

  }

  // convenience getter for easy access to form fields
  get f1() { 
    return this.loginForm.controls; 
  }

   onLoginSubmit() {
    this.submitted = true;

    // stop here if form is invalid
    if (this.loginForm.invalid) {
      return;
     }

     //console.log("login 1");
    

     //20250602 axa inici
     //this.loading = true;
     this.loadingSTD = true;
     //20250602 axa final

    // reset login status
    this.auth.logout().subscribe();

    // login       
    this.auth.login( this.f1.username.value, this.f1.password.value).subscribe( user => {
      $("#modal-login").modal('hide');
      $("#modal-login-registre-productes").modal('hide');
      this.submitted = false;
      //20250602 axa inici
      //this.loading = false;
      this.loadingSTD = false;
      //20250602 axa final
      this.f1.password.reset();
      this.router.navigate(['/']);
    }, error => {
      this.submitted = false;
      //20250602 axa inici
      //this.loading = false;
      this.loadingSTD = false;
      //20250602 axa final
      this.toastr.error( this.translate.instant(`LOGIN.LOGIN_ERROR`));
      this.f1.password.reset();
    });

    // console.log("login 2");

    //  this.auth.login( this.f1.username.value, this.f1.password.value).then(data =>{
    //     $("#modal-login").modal('hide');
    //     $("#modal-login-registre-productes").modal('hide');
    //     this.router.navigate(['/']);
    //  }).catch( ex => {
    //     this.toastr.error( this.translate.instant(`LOGIN.LOGIN_ERROR`));
    //     this.submitted = false;
    //     this.loading = false;
    //     this.f1.password.reset();
    //  });

  }

  //20250602 axa inici

onLoginSubmitAxA() {
  this.submitted = true;

  // stop here if form is invalid
  if (this.loginForm.invalid) {
    return;
  }

  //console.log("login axa");
  this.loadingAxA = true;

  // reset login status
  this.auth.logout().subscribe();

  // login
  this.auth.loginAxA(this.f1.username.value, this.f1.password.value).subscribe(user => {
    $("#modal-login").modal('hide');
    $("#modal-login-registre-productes").modal('hide');
    this.submitted = false;
    this.loadingAxA = false;
    this.f1.password.reset();
    this.router.navigate(['/login/deliveryAxA']);
  }, error => {
    console.log(error);
    this.submitted = false;
    this.loadingAxA = false;
    this.toastr.error(this.translate.instant(`LOGIN.LOGIN_ERROR`));
    this.f1.password.reset();
  });
}

showModalModalities(){
  //[attr.data-toggle]="'modal'" [attr.data-target]="'#modal-modalities'"
  $('#modal-login').modal('hide');
  $('#modal-modalities').modal('show');

}

  //20250602 axa final
}

